import { render, staticRenderFns } from "./UserCRUDModal.vue?vue&type=template&id=7ed5b700"
import script from "./UserCRUDModal.vue?vue&type=script&lang=js"
export * from "./UserCRUDModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports